import axios from "@/axios";

export default {
    namespaced: true,
    state: {
        profile: {}
    },
    getters: {
        profile: state => state.profile,
        accountStatus: state => state.profile?.status,
        verificationStatus: state => state.profile?.verification_data?.status,
        verificationSubmitted: state => state.profile?.verification_data?.status === 'submitted',
        isVerified: ({ profile }) => profile.status === 'approved',
        isNotVerified: ({ profile }) => profile.status === 'denied',
        is2FAEnabled: state => state.profile?.is_2fa_enabled || false,
        is2FASetupRequired: state => state.profile?.is_2fa_enabled && !state.profile?.google2fa_confirmed_at,
    },
    actions: {
        async fetchProfile({ commit }) {
            try {
                const { data } = await axios.get(process.env.VUE_APP_API + 'user/profile');
                commit('SET_PROFILE', data);
                return data;
            } catch (e) {
                console.log(e);
            }

            return null;
        },
        async fetchProfileUnverified({ commit }) {
            try {
                const { data } = await axios.get(process.env.VUE_APP_API + 'user/profile-unverified');
                commit('SET_PROFILE', data);
                return data;
            } catch (e) {
                console.log(e);
            }

            return null;
        },
        async initializeEnrollment() {
            try {
                const { data } = await axios.get(process.env.VUE_APP_API + 'finchecker/enrolment');
                return data.payload
            } catch (e) {
                console.log(e);
            }
        },
        // eslint-disable-next-line no-empty-pattern
        async checkEnrollmentStatus({ }, sessionId) {
            try {
                const { data } = await axios.get(process.env.VUE_APP_API + `finchecker/check/${sessionId}`);
                return data;
            } catch (e) {
                console.log(e);
            }
        }
    },
    mutations: {
        SET_PROFILE(state, profile) {
            state.profile = {
                ...profile,
                google2fa_confirmed_at: profile.google2fa_confirmed_at
            };
        },
        SET_PROFILE_STATUS(state, status) {
            state.profile = {
                ...state.profile,
                status
            }
        }
    }
}